import React from "react";
import Image from "../../components/ui/image";
import { Images } from "../../lib/images";
import { useNavigate } from "react-router-dom";

function Explore() {
  const navigate =  useNavigate();
  return (
    <section className="px-5">
      <div className="container mx-auto py-16">
        <div className="exploreBg grid grid-cols-1 md:grid-cols-12 gap-5 rounded-xl">
          <div className="col-span-5 text-center md:text-left">
            <Image
              alt=""
              src={Images.Exploreplayer}
              className="w-72 inline md:w-auto"
            />
          </div>
          <div className="col-span-7 xl:pt-20 text-center md:text-left">
            <h2 className="headingB pb-4 !text-white text-center md:text-left">
              Explore Football Analytics?
            </h2>
            <p className="commonTxt !text-white lg:!text-xl lg:!leading-[36px] pb-3">
              Dive into comprehensive club data, compare performance metrics,
              and discover what makes the biggest clubs in world football truly
              great.
            </p>
            <div className="flex flex-col md:flex-row gap-5 pt-5 justify-center md:justify-start">
              <button className="redButton !py-4 !text-xs lg:!text-base px-2 lg:px-5" onClick={()=>navigate('/league-table')}>View League Table</button>
              <button className="blueButton !py-4 !text-xs lg:!text-base px-2 lg:px-5" onClick={()=>navigate('/analytics')}>Explore Analytics</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Explore;
